import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { getStrategyProfile, getStrategyWeek, getStrategyBridge } from "@/lib/api";
import { IdentityCard } from "./strategia/IdentityCard";
import { FilieraPanel } from "./strategia/FilieraPanel";
import { MetodoPanel } from "./strategia/MetodoPanel";
import { WeekPlanPanel } from "./strategia/WeekPlanPanel";
import { DiagnosiPanel } from "./strategia/DiagnosiPanel";
import { LandingPanel } from "./strategia/LandingPanel";
import { SemaforoPanel } from "./strategia/SemaforoPanel";

export default function Strategia() {
  const [profile, setProfile] = useState(null);
  const [week, setWeek] = useState(null);
  const [bridge, setBridge] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadWeek = useCallback(async (start) => {
    try { setWeek(await getStrategyWeek(start || undefined)); } catch { toast.error("Errore nel caricamento della settimana"); }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const [p, w] = await Promise.all([getStrategyProfile(), getStrategyWeek()]);
        setProfile(p);
        setWeek(w);
      } catch {
        toast.error("Errore nel caricamento della strategia");
      } finally {
        setLoading(false);
      }
      getStrategyBridge().then(setBridge).catch(() => {});
    })();
  }, []);

  if (loading) {
    return <div className="flex items-center gap-2 text-neutral-500 text-sm" data-testid="strategy-loading"><Loader2 size={16} className="animate-spin" /> Carico la strategia…</div>;
  }

  return (
    <div className="space-y-8" data-testid="strategy-page">
      <IdentityCard profile={profile} onSaved={setProfile} />
      <DiagnosiPanel onProfileApplied={setProfile} />
      <WeekPlanPanel week={week} onNavigate={loadWeek} onChange={setWeek} />
      <LandingPanel />
      <SemaforoPanel />
      <FilieraPanel bridge={bridge} />
      <MetodoPanel profile={profile} />
    </div>
  );
}
